import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiControllerAgentChat: build.mutation<
      ApiControllerAgentChatApiResponse,
      ApiControllerAgentChatApiArg
    >({
      query: (queryArg) => ({
        url: `/web/agent/chat`,
        method: 'POST',
        body: queryArg.agentChatRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type ApiControllerAgentChatApiResponse =
  /** status 200 Agent answer plus the trace of every tool call used to derive it */ AgentChatResponse;
export type ApiControllerAgentChatApiArg = {
  agentChatRequest: AgentChatRequest;
};
export type AgentChatToolTraceDto = {
  name: string;
  arguments: {
    [key: string]: any;
  };
  result: {
    [key: string]: any;
  };
  durationMs: number;
  error?: string;
};
export type AgentChatUsageDto = {
  promptTokens: number | null;
  completionTokens: number | null;
  totalTokens: number | null;
};
export type AgentChatData = {
  /** Final assistant answer (in the same language as the user message) */
  answer: string;
  /** Trace of every tool call the agent made while answering */
  trace: AgentChatToolTraceDto[];
  usage: AgentChatUsageDto;
  /** Total processing time in ms */
  durationMs: number;
  /** True if the agent hit the tool-call iteration limit before finishing */
  truncated: boolean;
};
export type AgentChatResponse = {
  /** Operation status */
  status: boolean;
  data: AgentChatData;
};
export type AgentChatHistoryItemDto = {
  role: 'user' | 'assistant';
  content: string;
};
export type AgentPageContextDto = {
  /** Frontend page identifier (e.g. "vault", "task", "wallet") */
  page?: string;
  vaultId?: number;
  taskId?: number;
  walletAddress?: string;
  blockchainId?: number;
  /** Free-form note from the frontend (optional) */
  note?: string;
};
export type AgentChatRequest = {
  message: string;
  /** Chat history (last messages); kept on the frontend, sent on every request */
  history?: AgentChatHistoryItemDto[];
  context?: AgentPageContextDto;
};
